<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Bank Accounts",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('bank_accounts.singular')) }},
    resourceRoute: {default: 'bank_accounts'},
    modelVariable: {default: 'bank_account'},
    denyDelete: {type: Boolean, default: true},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
          href: "/bank_accounts",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/bank_accounts/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.customer`)),
          value: this.model.customer.name,
        },
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.bank`)),
          value: this.model.bank.name
        },
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.account_number`)),
          value: this.model.account_number,
        }
      ]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/bank_accounts/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/bank_accounts/${this.$route.params.key}`, {
        params: {
          with: 'customer,bank'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    }
  }
}
</script>
